import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, 
  FormControlLabel, Switch, Box, Grid, Typography
} from '@mui/material';

interface SectionFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  initialData?: any;
  trainingId: number;
  nextOrder?: number;
}

const SectionForm: React.FC<SectionFormProps> = ({ 
  open, onClose, onSubmit, initialData, trainingId, nextOrder = 1
}) => {
  const [form, setForm] = useState({
    title: '',
    description: '',
    order: nextOrder,
    is_required: true
  });

  useEffect(() => {
    if (initialData) {
      setForm({
        title: initialData.title || '',
        description: initialData.description || '',
        order: initialData.order || 1,
        is_required: initialData.is_required !== false
      });
    } else {
      setForm({
        title: '',
        description: '',
        order: nextOrder,
        is_required: true
      });
    }
  }, [initialData, open, nextOrder]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: parseInt(value, 10) || 0
    }));
  };

  const handleSubmit = () => {
    const formData = {
      ...form,
      training: trainingId,
      order: form.order ? parseInt(form.order.toString(), 10) : 1
    };
    onSubmit(formData);
  };

  const isFormValid = () => {
    return form.title.trim() !== '';
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {initialData ? 'Edit Section' : 'Add New Section'}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="Section Title"
              name="title"
              value={form.title}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          
          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="Description"
              name="description"
              value={form.description}
              onChange={handleChange}
              multiline
              rows={3}
              fullWidth
            />
          </Grid>
          
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  name="is_required"
                  checked={form.is_required}
                  onChange={handleChange}
                />
              }
              label="Required Section"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained"
          disabled={!isFormValid()}
        >
          {initialData ? 'Save Changes' : 'Create Section'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SectionForm; 